module.exports = __webpack_public_path__ + "static/media/credit-card.17f4f6f2.svg";